import { Component } from '@angular/core';

@Component({
  selector: 'icon-aumento-pgu-infografia-mobile',
  templateUrl: './aumento-pgu-infografia-orientacion-abajo.svg',
  styles: ['svg { display: block; width: 100%; height: auto; }'],
  standalone: true,
})
export class AumentoPguInfografiaMobileComponent {}
